<template>
  <div class="row" id="areas">
    <div class="col-12">
      <div class="container-xxl">
        <div class="">

          <div class="areas ">
            <div><h2 class="title">Qual área de <strong>carreira</strong> te interessa?</h2></div>

            <div class="area-text" v-if="occupationSelected">
              <div class="card" >
                <h3>{{ occupationSelected.title }}</h3>
                <p>{{occupationSelected.content}}</p>
                <div><router-link to='vagas' class="btn btn-color-1 rounded-xl text-color-2 px-4">Confira as oportunidades</router-link></div>
              </div>
            </div>
            <div class="area-buttons">
              <div class="area"  @click="selectArea" v-for="(item, i) in occupationArea" :key="i">
                <img class="img1" :id="item.title" :src="require(`@/assets/images/areas/${ item.image }`)" :alt="item.title" :class="{ 'd-none': occupationSelected.title == item.title }" />
                <img class="img2" :id="item.title" :src="require(`@/assets/images/areas/${ item.image2 }`)" :alt="item.title" :class="{ 'd-inline': occupationSelected.title == item.title }" />
                <p>{{ item.title }}</p>
              </div>
            </div>
          </div>

        </div>
      </div>
    </div>
  </div>
</template>

<script>
  export default {
    name: 'Areas',

    data(){
      return {
        occupationSelected:{
          "title":"Recursos Humanos",
          "content":"Trabalhamos para compreender as necessidades dos colaboradores, nossos colegas, e propor uma jornada de desenvolvimento humanizada e produtiva, para que cada um possa atingir o máximo de seu potencial.",
        },
      }
    },

    computed: {
      occupationArea(){
        return this.$store.state.occupationArea;
      },
    },

    methods: {
      selectArea(){
        let areaSelected = event.target.id;
        const areas = this.$store.state.occupationArea;
        this.occupationSelected =  areas.find((item) =>{
          if(item.title == areaSelected ){
            return item
          }
        });

        return this.occupationSelected;
      },
    }
  }
</script>

<style lang="scss" scoped>
  #areas{
    background-color: #f5f5f5;
    padding: 0 40px;
    @media screen and (max-width: 1100px) {
      padding: 0;
    }
  }

  .areas{
    width: 100%;
    justify-content: center;
    flex-direction: column;
    color: #0A1D6F;
    .title{
      padding-top: 40px;
      font-size: 36px;
      text-align: center;
      font-weight: 400;
      strong{
        color: #00CFD9;
      }
    }

    .area-text{
      padding: 40px 0;
      display: flex;
      justify-content: center;
      .card{
        border: 2px solid #0A1D6F;
        border-radius: 20px;
        padding: 20px;
        width: 100%;

        h3{
          font-weight: 700;
        }
      }

      @include media-breakpoint-down(md){
        padding: 40px 20px;
        .card{
          width: auto;
        }
      }

      @include media-breakpoint-down(sm) {
        .card{
          a{
          padding: 10px 4px;
          font-size: 10px;
        }
        }
      }
    }

    .area-buttons{
      display: flex;
      flex-wrap: wrap;
      justify-content: center;
      padding: 0;

      @include media-breakpoint-down(sm) {
        width: 100%;
        flex-wrap: nowrap;
        overflow: auto;
        justify-content: flex-start;
      }


      .area{
        width: calc(100% / 6);
        text-align: center;
        margin: 0 0 40px 0;
        flex-shrink: 0;
        cursor: pointer;

        @include media-breakpoint-down(sm) {
          width: calc(100% / 3);
          margin: 10px;
        }

        img{
          width: 100px;
        }
          .img2{
            display: none;
          }

        p{
          font-weight: bold;
          margin: 5px 0 0 0;
        }

        &:hover{
          .img1{
            display: none;
          }
          .img2{
            display: inline-block;
          }
        }
      }

    }
  }
</style>